import { materialCells, materialRenderers } from "@skrice.studio/material-renderers";
import { Generate, rankWith, uiTypeIs } from "@jsonforms/core";
import { JsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
    Autocomplete, Breadcrumbs,
    Button,
    CardHeader,
    debounce,
    FormControl,
    Grid,
    Link,
    Paper, Skeleton, TextareaAutosize,
    TextField,
    Typography
} from "@mui/material";
import axios from "axios";
import { Buffer } from "buffer";
import * as React from "react";
import ReactJson from "react-json-view";
import { Config } from "../../../../config/config";
import { getGlobalVar, Helpers } from "../../../../utils/helpers";
import { PopupMessage } from "../../../../utils/message";

const OFFER_PACK_PAGING = 10;

enum ConfigDataType {
    SHOP_DATA = 1,
    SHOP_DATA_GAME_SERVER = 2,
    SHOP_PACKAGES = 3,
    ITEM_WEAPONS_GAME_FILE = 4,
}
interface Props {
    activeUser: any;
    activeEnv: any;
    classes: any;
    form: any;
    match: any;
    history: any;
    location: any;
    fullWidth?: boolean;
    hideBreadcrumbs?: boolean;
    hideSaveButton?: boolean;
}

interface State {
    loaded: boolean;
    fileKey: string;
    filepath: string;
    jsonSchema: any;
    uiSchema: any;
    content: any;
    contentAll: any;
    rawValue: string;
    toggleRawJson: boolean;
    saving: boolean;
    fileSource: string;
    offerPackIndex: number;
}

const GAME_ITEMS = getGlobalVar("ITEMS").map(item => {
    const name = Helpers.getLocalizationName(item.name);

    return {
        ...item,
        name,
        firstLetter: item.type.replace("_", " ").toUpperCase(),
    };
});

const ItemControl = (control) => {
    const handleChange = (_e, newItem) => {
        control.handleChange(control.path, newItem.id);
    };

    const getOptionLabel = (option) => {
        if (typeof option === "number" || typeof option === "string") {
            const item = GAME_ITEMS.find(_item => _item.id === option);

            return item?.name || "Item not found!";
        }

        return option.name;
    };

    return <FormControl style={{
        marginRight: 8,
        width: "100%",
        marginBottom: 10,
    }}>
        <Autocomplete
            onChange={handleChange}
            value={control.data}
            options={GAME_ITEMS.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={option => option.firstLetter}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={(option, value) => option.id === value}
            size="small"
            renderInput={(params) =>
                <TextField {...params} label={control.label} id={`reward_select_${control.path}`} variant="outlined" size="small"/>}
        />
    </FormControl>;
};

const renderers = [
    ...materialRenderers,

    {tester: rankWith(3, uiTypeIs("GameItems")), renderer: withJsonFormsControlProps(ItemControl)}
];

export class EditFile extends React.Component<Props, State> {

    private mounted: boolean;
    private updateTimeout: any;
private errors: Map<string, any>;
    private isShopData: boolean;
    private isShopDataGameServer: boolean;
    private isShopPackage: boolean;
    private configDataType: ConfigDataType;

    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            fileKey: this.props.match.params.key,
            fileSource: new URLSearchParams(this.props.location.search).get("source"),
            filepath: (Buffer.from(this.props.match.params.key, "base64").toString("ascii")),
            jsonSchema: {},
            uiSchema: {},
            content: {},
            contentAll : {},
            rawValue: "",
            toggleRawJson: false,
            saving: false,
            offerPackIndex: 0,
        };
        this.errors = new Map<string, any>();

        document.title = Helpers.documentTitle(`Item Editor - ${this.state.filepath}`);
        this.isShopData = false;
        this.isShopDataGameServer = false;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidMount() {
        this.mounted = true;
        this.fetchData();
    }

    saveFile = async ({formData}, _e) => {
        this.setState({
            saving: true
        });

        try {
            await axios.post(
                `${Config.getInstance.apiUrl}/api/item_editor/${this.state.fileSource}/${this.state.fileKey}`,
                {
                    content: formData,
                },
                this.headers(),
            );
            PopupMessage.success("File uploaded!");
        } catch (e) {
            PopupMessage.error(e.response?.data.message || e.message);
        }

        this.setState({
            saving: false
        });
    };

checkAndShowError() {
        if (this.errors.size > 0) {
            const firstData: any = Array.from(this.errors)[0];
            this.errors.delete(firstData[0]);
            PopupMessage.error(`Form error: ${firstData[0]} ${firstData[1].message}`, 10);
            
            if (this.errors.size > 0) {
                setTimeout(() => {
                    this.checkAndShowError();
                }, 200)
            }
        }
    }

    addError(error) {
        const size = this.errors.size;
        if (size >= 100) // maxe queue 1000 messges
            return;
        const dataCheck = this.errors.get(error.instancePath);
        if (!dataCheck) {
            this.errors.set(error.instancePath, error);
            if (size === 0)
                setTimeout(() => {
                    this.checkAndShowError();
                }, 200);
        }
    }
    saveError(errors) {
        /*errors.forEach(err => {
            PopupMessage.error(`Form error: ${err.dataPath} ${err.message}`, 10);
        });
        this.setState({errorCount: this.state.errorCount + errors.length});
        console.log("errors", this.state.errorCount);*/
        errors.forEach(err => {
            this.addError(err);
        });
    }

    async fetchData() {
        try {
            console.log("Fetch data...");

            const response = await axios.get(`${Config.getInstance.apiUrl}/api/item_editor/${this.state.fileSource}/${this.state.fileKey}`, this.headers());
            if (response.data.content) {
                if (response.data.content.botConfig) {
                    for (let i =0; i<response.data.content.botConfig.length; i++){
                        const bc = response.data.content.botConfig[i];
                        if (bc.minRank === null) bc.minRank = 0;
                        if (bc.maxRank === null) bc.maxRank = 0;
                    }

                    if (response.data.content.lootPenalties && response.data.content.matchmakingCost) {
                
                        for (let i=0; i<response.data.content.lootPenalties.length; i++) {
                            response.data.content.lootPenalties[i].loot = response.data.content.lootPenalties[i].loot.toFixed(2);
                        }
                   }

               } else if (response.data.content.offerPacks) {
                if (response.data.content.shopPacks) {
                    for(let i=0; i<response.data.content.shopPacks.length; i++) {
                        if (response.data.content.shopPacks[i].items && response.data.content.shopPacks[i].items.length > 0) {
                            for(let j=0; j<response.data.content.shopPacks[i].items.length; j++) {
                                response.data.content.shopPacks[i].items[j].itemId = response.data.content.shopPacks[i].items[j].itemId.toString();
                            }
                        }
                    }
                    
                    this.isShopDataGameServer = true;
                }
                else this.isShopData = true;
               } else if (response.data.content.items && response.data.content.items.length > 0 && response.data.content.items[0].productId && response.data.content.items[0].price) {
                    /*for (let i=0; i<response.data.content.items.length; i++) {
                        response.data.content.items[i].price = response.data.content.items[i].price.toFixed(3);
                    }*/
                    this.isShopPackage = true;
               } else if (response.data.content.hasOwnProperty("items") && response.data.content.items.length > 0 && response.data.content.items[0].hasOwnProperty("league") && response.data.content.hasOwnProperty("cashPackItems")) {
                    this.configDataType = ConfigDataType.ITEM_WEAPONS_GAME_FILE;
               }
            }

            //console.log("Fetch data done", response.data.content);

            if (this.mounted) {
                const offerPacks = []
                //let content = this.isShopData ? {goldPacks: response.data.content.goldPacks, offerPacks} : response.data.content;
                let content = this.isShopData ? {sapphirePacks: response.data.content.sapphirePacks, offerPacks} : response.data.content;
                if (this.isShopData) {
                    let len = OFFER_PACK_PAGING;
                    for (let i=0; i<len; i++) {
                        content.offerPacks.push(response.data.content.offerPacks[i]);
                    }
                } else if (this.isShopPackage) {
                    content = {items: []};
                    let len = OFFER_PACK_PAGING;
                    for (let i=0; i<len; i++) {
                        content.items.push(response.data.content.items[i]);
                    }
                } else if (this.isShopDataGameServer) {
                    if (response.data.content.goldPacks) {
                        response.data.content.sapphirePacks = response.data.content.goldPacks;
                        delete response.data.content.goldPacks;
                    }
                    
                    content = {sapphirePacks: response.data.content.sapphirePacks, 
                                rotationPacks: response.data.content.rotationPacks,
                                shopPacks: response.data.content.shopPacks,
                        offerPacks: []};
                    let len = OFFER_PACK_PAGING;
                    for (let i=0; i<len; i++) {
                        if (response.data.content.offerPacks[i].desc) {
                            if (!response.data.content.offerPacks[i].desc.type) response.data.content.offerPacks[i].desc.type = "";
                            if (!response.data.content.offerPacks[i].desc.level) response.data.content.offerPacks[i].desc.level = 0;
                        }
                        if (response.data.content.offerPacks[i].conditions && response.data.content.offerPacks[i].conditions.length) {
                            for (let j=0; j<response.data.content.offerPacks[i].conditions.length; j++) {
                                response.data.content.offerPacks[i].conditions[j].value = response.data.content.offerPacks[i].conditions[j].value.toString();
                                if (!response.data.content.offerPacks[i].conditions[j].secondValue) response.data.content.offerPacks[i].conditions[j].secondValue = '';
                            }
                        }
                        if (response.data.content.offerPacks[i].images) {
                            if (!response.data.content.offerPacks[i].images.icon) response.data.content.offerPacks[i].images.icon = '';
                            if (!response.data.content.offerPacks[i].images.background) response.data.content.offerPacks[i].images.background = '';
                        }
                        if (!response.data.content.offerPacks[i].extraValue) response.data.content.offerPacks[i].extraValue = 0;
                        if (response.data.content.offerPacks[i].items) {
                            for (let j=0; j<response.data.content.offerPacks[i].items.length; j++) {
                                response.data.content.offerPacks[i].items[j].itemId = response.data.content.offerPacks[i].items[j].itemId.toString();
                                if (!response.data.content.offerPacks[i].items[j].level) response.data.content.offerPacks[i].items[j].level = 0;
                                if (!response.data.content.offerPacks[i].items[j].premiumValue) response.data.content.offerPacks[i].items[j].premiumValue = 0;
                            }
                        }
                        if (!response.data.content.offerPacks[i].badgeColor) response.data.content.offerPacks[i].badgeColor = '';
                        content.offerPacks.push(response.data.content.offerPacks[i]);
                    }

                    //console.log("content", content);
                }
                /*const data = this.isShopData ? {jsonSchema: response.data.jsonSchema, uiSchema: response.data.uiSchema, content} : 
                    {...response.data};*/
                const data = this.isShopData || this.isShopPackage || this.isShopDataGameServer ? 
                {jsonSchema: response.data.jsonSchema, uiSchema: response.data.uiSchema, content} : 
                    {...response.data};
                
                this.setState({
                    //...response.data,
                    ...data
                });
                this.setState({
                    contentAll: response.data.content
                });                

                this.setState({
                    //rawValue: JSON.stringify(this.state.content, null, "  "),
                    rawValue: JSON.stringify(content, null, "  "),
                });
                let schema = this.state.jsonSchema;
                let uiSchema = this.state.uiSchema;
                //let schemaConent = this.isShopData ? {goldPacks: [content.goldPacks[0]], offerPacks: [content.offerPacks[0]]} : this.state.content;
                let schemaConent = this.isShopData ? {sapphirePacks: [content.sapphirePacks[0]], offerPacks: [content.offerPacks[0]]} : this.state.content;
                if (this.isShopPackage) schemaConent = {items: [schemaConent.items[0]]};
                else if (this.isShopDataGameServer) schemaConent = {
                    offerPacks: [content.offerPacks[0]],
                    rotationPacks: [content.rotationPacks[0]],
                    sapphirePacks: [content.sapphirePacks[0]], 
                    shopPacks: [content.shopPacks[0]],
                }
                if (Object.keys(schema).length <= 0) {
                    //schema = Generate.jsonSchema(this.state.content);
                    schema = Generate.jsonSchema(schemaConent);
                }
                if (Object.keys(uiSchema).length <= 0) {
                    uiSchema = Generate.uiSchema(schema);
                }

                this.setState({
                    jsonSchema: schema,
                    uiSchema
                });
            }
        } catch (e) {
            PopupMessage.error(e.response?.data.message || e.message);
        }

        if (this.mounted) {
            this.setState({
                loaded: true,
            });
        }
    }

    changeRawJson = (e) => {
        this.setState({
            rawValue: e.target.value,
        });
        clearTimeout(this.updateTimeout);
        this.updateTimeout = setTimeout(() => {
            try {
                this.setState({
                    content: JSON.parse(this.state.rawValue),
                });
            } catch (e) {
                PopupMessage.error("Unable to parse JSON value: " + e.message);
            }
        }, 500);
    };

    changeFormJson = ({errors, data}) => {
        if (errors.length > 0) {
            if (this.configDataType !== ConfigDataType.ITEM_WEAPONS_GAME_FILE)
                this.saveError(errors);

            console.error(errors);

            return;
        }

        this.setState({
            rawValue: JSON.stringify(data, null, 4)
        });
    };

    saveRawJson = async () => {
        const json = JSON.parse(this.state.rawValue);
        let dataSave = json;

        // replace data into data all
        if (this.isShopData || this.isShopDataGameServer) {
            //this.state.contentAll.goldPacks = json.goldPacks;
            this.state.contentAll.sapphirePacks = json.sapphirePacks;
            let end = this.state.offerPackIndex + OFFER_PACK_PAGING;
            if (end > this.state.contentAll.offerPacks.length) end = this.state.contentAll.offerPacks.length;
            let idx = 0;
            for (let i=this.state.offerPackIndex; i<end; i++) {
                this.state.contentAll.offerPacks[i] = json.offerPacks[idx++];
            }
            dataSave = this.state.contentAll;
        } else if (this.isShopPackage) {
            let end = this.state.offerPackIndex + OFFER_PACK_PAGING;
            if (end > this.state.contentAll.items.length) end = this.state.contentAll.items.length;
            let idx = 0;
            for (let i=this.state.offerPackIndex; i<end; i++) {
                this.state.contentAll.items[i] = json.items[idx++];
            }
            dataSave = this.state.contentAll;
        }
        await this.saveFile({
            //formData: this.state.contentAll,
            formData: dataSave
        }, null);
    };

refreshContent = (start: number) => {
        const content = {...this.state.content};
        if (this.isShopData) {
            content.offerPacks = [];
            let idx = 0;
            let end = start + OFFER_PACK_PAGING;
            if (end > this.state.contentAll.offerPacks.length) end = this.state.contentAll.offerPacks.length;
            for (let i=start; i<end; i++) {
                content.offerPacks[idx] = this.state.contentAll.offerPacks[i];
                if (!content.offerPacks[idx].subtitle) content.offerPacks[idx].subtitle = "";
                if (!Number.isInteger(content.offerPacks[idx].extraValue)) content.offerPacks[idx].extraValue = 0;
                for (let j=0; j<content.offerPacks[idx].items.length; j++) {
                    if (content.offerPacks[idx].items[j].amount === null) content.offerPacks[idx].items[j].amount = 0;
                }
                idx++;
            }
        } else if (this.isShopPackage) {
            content.items = [];
            let idx = 0;
            let end = start + OFFER_PACK_PAGING;
            if (end > this.state.contentAll.items.length) end = this.state.contentAll.items.length;
            for (let i=start; i<end; i++) {
                content.items[idx] = this.state.contentAll.items[i];
                
                idx++;
            }
        } else if (this.isShopDataGameServer) {
            content.offerPacks = [];
            let idx = 0;
            let end = start + OFFER_PACK_PAGING;
            if (end > this.state.contentAll.offerPacks.length) end = this.state.contentAll.offerPacks.length;
            for (let i=start; i<end; i++) {
                content.offerPacks[idx] = this.state.contentAll.offerPacks[i];
                /*if (content.offerPacks[idx].desc) {
                    if (!content.offerPacks[idx].desc.type) content.offerPacks[idx].desc.type = "";
                    if (!content.offerPacks[idx].desc.level) content.offerPacks[idx].desc.level = 0;
                }
                if (!content.offerPacks[idx].subtitle) content.offerPacks[idx].subtitle = "";
                if (!Number.isInteger(content.offerPacks[idx].extraValue)) content.offerPacks[idx].extraValue = 0;*/
                if (content.offerPacks[idx].desc) {
                    if (!content.offerPacks[idx].desc.type) content.offerPacks[idx].desc.type = "";
                    if (!content.offerPacks[idx].desc.level) content.offerPacks[idx].desc.level = 0;
                }
                if (content.offerPacks[idx].conditions && content.offerPacks[idx].conditions.length) {
                    for (let j=0; j<content.offerPacks[idx].conditions.length; j++) {
                        content.offerPacks[idx].conditions[j].value = content.offerPacks[idx].conditions[j].value.toString();
                        if (!content.offerPacks[idx].conditions[j].secondValue) content.offerPacks[idx].conditions[j].secondValue = '';
                    }
                }
                if (content.offerPacks[idx].images) {
                    if (!content.offerPacks[idx].images.icon) content.offerPacks[idx].images.icon = '';
                    if (!content.offerPacks[idx].images.background) content.offerPacks[idx].images.background = '';
                }
                if (!content.offerPacks[idx].extraValue) content.offerPacks[idx].extraValue = 0;
                if (content.offerPacks[idx].items) {
                    for (let j=0; j<content.offerPacks[idx].items.length; j++) {
                        content.offerPacks[idx].items[j].itemId = content.offerPacks[idx].items[j].itemId.toString();
                        if (!content.offerPacks[idx].items[j].level) content.offerPacks[idx].items[j].level = 0;
                        if (!content.offerPacks[idx].items[j].premiumValue) content.offerPacks[idx].items[j].premiumValue = 0;
                    }
                }
                if (!content.offerPacks[idx].badgeColor) content.offerPacks[idx].badgeColor = '';
                //content.offerPacks.push(content.offerPacks[i]);
                
                idx++;
            }
        }
        this.setState({
            offerPackIndex: start
        });
        this.setState({
            content
        });
    }

    onPreviusPage = () => {
        const current = this.state.offerPackIndex / OFFER_PACK_PAGING + 1;
        let len = 0;
        if (this.isShopData || this.isShopDataGameServer) len = this.state.contentAll.offerPacks.length;
        else if (this.isShopPackage) len = this.state.contentAll.items.length;
        //const totalPage = parseInt((this.state.contentAll.offerPacks.length / OFFER_PACK_PAGING + 1).toFixed(0));
        if (current > 1)
            this.refreshContent(this.state.offerPackIndex - OFFER_PACK_PAGING);
    }

    onNextPage = () => {
        const current = this.state.offerPackIndex / OFFER_PACK_PAGING + 1;
        let len = 0;
        if (this.isShopData || this.isShopDataGameServer) len = this.state.contentAll.offerPacks.length;
        else if (this.isShopPackage) len = this.state.contentAll.items.length;
        //const totalPage = parseInt((this.state.contentAll.offerPacks.length / OFFER_PACK_PAGING + 1).toFixed(0));
        const totalPage = Math.trunc(len / OFFER_PACK_PAGING) + 1;
        if (current < totalPage)
            this.refreshContent(this.state.offerPackIndex + OFFER_PACK_PAGING);
    }
    formatRawJson = () => {
        const json = JSON.parse(this.state.rawValue);
        this.setState({
            rawValue: JSON.stringify(json, null, "  "),
        });
    };

    headers() {
        return {
            headers: {Authorization: Helpers.getSessionId()},
            timeout: 30000
        };
    }

    renderForm() {
        if (!this.state.toggleRawJson) {
            return <JsonForms
                schema={this.state.jsonSchema}
                uischema={this.state.uiSchema}
                data={this.state.content}
                renderers={renderers}
                cells={materialCells}
                // validationMode={'NoValidation'}
                onChange={debounce(this.changeFormJson, 500)}
            />;
        }

        return (
            <Grid xs={12} style={{overflow: "auto"}}>
                <Grid xs={6} style={{float: "left", width: "50%"}}>
                    <TextareaAutosize
                        style={{width: "100%"}}
                        value={this.state.rawValue}
                        onChange={this.changeRawJson}
                    />
                    <Button disableElevation
                        variant="contained"
                        color="primary"
                        onClick={this.formatRawJson}
                    >
                        Format JSON
                    </Button>
                </Grid>
                <Grid xs={6} style={{float: "left", width: "50%"}}>
                    <ReactJson
                        src={this.state.content}
                    />
                </Grid>
            </Grid>
        );
    }

    renderSchemaActions() {
        return (
            <React.Fragment>
                <Button
                    disableElevation
                    key="raw-json"
                    onClick={() => this.setState({toggleRawJson: !this.state.toggleRawJson})}
                    variant="contained"
                    size="small"
                >
                    Toggle RAW JSON
                </Button>
            </React.Fragment>
        );
    }

    urlWithBasePath = (url) => {
        let base = url.replace("/bundle/", "").replace("/bundle", "");

        if (base.slice(-1) !== "/") {
            base += "/";
        }

        return base;
    }

    handleBreadcrumbLink = (event) => {
        event.preventDefault();
        const fileName = this.urlWithBasePath(event.target.getAttribute("href"));

        this.props.history.push(Helpers.fullUrl(fileName));
    };

    renderSaveButton() {
        if (this.state.saving) {
            return <Button disableElevation
                variant="contained"
                color="primary"
                disabled={true}
            >
                Saving...
            </Button>;
        }

        return (
        <>
            <Button disableElevation
                variant="contained"
                onClick={this.saveRawJson}
                color="primary"
            >
                Save
            </Button>&nbsp;&nbsp;
            {this.isShopData || this.isShopPackage || this.isShopDataGameServer ?
                <Button disableElevation
                    variant="contained"
                    onClick={this.onPreviusPage}
                    color="primary"
                >
                    Previous Page
                </Button> : null
            }
            {this.isShopData || this.isShopPackage || this.isShopDataGameServer ? '  ' : null }
            
            {this.isShopData || this.isShopPackage || this.isShopDataGameServer ?
                <Button disableElevation
                    variant="contained"
                    onClick={this.onNextPage}
                    color="primary"
                >
                    Next Page
                </Button> : null
            }
            {this.isShopData || this.isShopPackage || this.isShopDataGameServer ? '  ' : null }
            {
                this.isShopData || this.isShopDataGameServer ? `${this.state.offerPackIndex / OFFER_PACK_PAGING + 1} / ${ Math.trunc(this.state.contentAll.offerPacks.length / OFFER_PACK_PAGING) + 1}`: 
                this.isShopPackage ? `${this.state.offerPackIndex / OFFER_PACK_PAGING + 1} / ${ Math.trunc(this.state.contentAll.items.length / OFFER_PACK_PAGING) + 1}` : null
            }
        </>
        );
    }

    getBreadcrumbs() {
        // Split url and remove empty elements
        const paths = this.state.filepath.split("/");

        if (paths[0] !== "") {
            paths.unshift("");
        }

        return <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small"/>}
            arial-label="Breadcrumb"
            className="bundle-breadcrumbs"
        >
            {paths.map((item, index) => {
                // Root item
                if (index === 0) {
                    return <Link
                        href={Helpers.fullUrl(item)}
                        onClick={this.handleBreadcrumbLink}
                        key={index}
                    >
                        {this.state.fileSource === "game" ? "Game files" : "Server files"}
                    </Link>;
                }

                // If last item in stack
                if (index === paths.length - 1) {
                    return <Typography color="textPrimary" key={item + index}>
                        {Helpers.capitalizeFirstLetter(item)}
                    </Typography>;
                }

                return <Link
                    href={Helpers.fullUrl(paths.slice(0, index + 1).join("/"))}
                    onClick={this.handleBreadcrumbLink}
                    key={index}
                >
                    {Helpers.capitalizeFirstLetter(item)}
                </Link>;
            })}
        </Breadcrumbs>;
    }

    render() {
        if (!this.state.loaded) {
            return <div className={this.props.fullWidth ? "" : "contentPadding"}>
                <Paper style={{padding: "10px"}} elevation={0}>
                    <CardHeader
                        title={<Skeleton variant="text" width={300}/>}
                        action={<Skeleton variant="text" width={130} height={25}/>}
                    />

                    <div style={{ padding: 16 }}>
                        <Skeleton variant="rectangular" height={150} />
                    </div>
                </Paper>
            </div>;
        }

        return (
            <div className={this.props.fullWidth ? "" : "contentPadding"}>
                <Paper style={{padding: "10px"}} elevation={0} className="json-editor">
                    <CardHeader
                        title={this.props.hideBreadcrumbs ? null : this.getBreadcrumbs()}
                        action={
                            this.renderSchemaActions()
                        }
                    />

                    <div style={{ padding: 16 }} className="logic-edit-form">
                        {this.renderForm()}
                    </div>

                    <div style={{ padding: 16 }}>
                        {this.props.hideSaveButton ? null : this.renderSaveButton()}
                    </div>
                </Paper>
            </div>
        );
    }
}